export interface ICallService {
  serviceName: string;
  duration?: number;
  pricePerInterval?: number;
  interval?: number;
  numberOfIntervals?: number;
  totalPrice?: number;
  serviceCode?: string;
}


export interface ICallRecording {
  name: string;
  nodeKey: string;
  duration: number;
  services: ICallService[];
  totalPrice: number;
}

export interface ICallAI {
  name: string;
  interval: number;
  pricePerInterval: number;
  services: ICallService[];
  totalPrice: number;
}

export interface ICallAskAiAsssitantPrice {
  model: string;
  type: string;
  askAiAssistantTotalInputTokens: number;
  askAiAssistantTotalOutputTokens: number;
  askAiAssistantInputNumberOfIntervals: number;
  askAiAssistantOutputNumberOfIntervals: number;
  askAiAssistantInputPricePerInterval: number;
  askAiAssistantOutputPricePerInterval: number;
  askAiAssistantInputPrice: number;
  askAiAssistantOutputPrice: number;
}

export interface ICallAiAgentPrice {
  model: string;
  priceListCode: string;
  totalTokens: number;
  numberOfIntervals: number;
  interval: number;
  basePricePerInterval: number;
  resellerPricePerInterval: number;
  pricePerInterval: number;
  basePrice: number;
  resellerPrice: number;
  price: number;
}


export const AiAgentPriceTypes = {
  RealtimeTextOutput: "RealtimeTextOutput",
  RealtimeAudioOutput: "RealtimeAudioOutput",
  RealtimeAudioInput: "RealtimeAudioInput",
  RealtimeTextInput: "RealtimeTextInput",
  RealtimeAudioInputCached: "RealtimeAudioInputCached",
  RealtimeTextInputCached: "RealtimeTextInputCached",
  RealtimeMinute: "RealtimeMinute",
  AskGenerativeAIInput: "AskGenerativeAIInput",
  AskGenerativeAIOutput: "AskGenerativeAIOutput",
  AskGenerativeAIInputCached: "AskGenerativeAIInputCached",
  AskGenerativeAIOutputCached: "AskGenerativeAIOutputCached"
} as const;

export type AiAgentPriceType = typeof AiAgentPriceTypes[keyof typeof AiAgentPriceTypes];

export const AiAgentPriceTypeLabels: Record<AiAgentPriceType, string> = {
  RealtimeTextOutput: "Output text",
  RealtimeAudioOutput: "Output audio",
  RealtimeAudioInput: "Input audio",
  RealtimeTextInput: "Input text",
  RealtimeAudioInputCached: "Input audio (cached)",
  RealtimeTextInputCached: "Input text (cached)",
  RealtimeMinute: "Realtime (per minute)",
  AskGenerativeAIInput: "Input (delegation model)",
  AskGenerativeAIOutput: "Output (delegation model)",
  AskGenerativeAIInputCached: "Input cached (delegation model)",
  AskGenerativeAIOutputCached: "Output cached (delegation model)"
};
